import React from "react";
import { ChevronLeft } from "@carbon/icons-react";

const FieldItem = ({ label, value, isFullWidth = false }) => (
  <div className={isFullWidth ? "uk-width-1-1" : ""}>
    <div className="uk-margin">
      <label className="uk-form-label" style={{ 
        fontSize: "11px", 
        color: "#999", 
        textTransform: "uppercase", 
        fontWeight: "600",
        letterSpacing: "0.5px",
        marginBottom: "8px",
        display: "block"
      }}>
        {label}
      </label>
      <p style={{ 
        fontSize: "15px", 
        color: "#333", 
        fontWeight: "500",
        margin: "0",
        lineHeight: "1.6"
      }}>
        {value || "-"}
      </p>
    </div>
  </div>
);

const DealershipDetail = ({ data, onBack }) => {
  return (
    <div className="uk-grid" uk-grid="">
      <div className="uk-width-1-1">
        <div className="uk-margin-medium-bottom">
          <button
            className="uk-button uk-button-default uk-button-small"
            onClick={onBack}
            style={{ 
              display: "flex", 
              alignItems: "center", 
              gap: "6px",
              padding: "8px 16px",
              borderRadius: "4px",
              backgroundColor: "#f8f8f8",
              border: "1px solid #e5e5e5",
              color: "#666",
              fontWeight: "500",
              fontSize: "14px"
            }}
          >
            <ChevronLeft size={18} />
            Back to List
          </button>
        </div>

        <div className="uk-card uk-card-default" style={{ 
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          borderRadius: "8px",
          border: "1px solid #e5e5e5"
        }}>
          <div className="uk-card-header" style={{ 
            backgroundColor: "#fafafa", 
            borderBottom: "2px solid #e5e5e5",
            padding: "24px 32px"
          }}>
            <h3 className="uk-card-title uk-margin-remove" style={{ 
              fontSize: "22px", 
              fontWeight: "600",
              color: "#333"
            }}>
              Dealership Application Details
            </h3>
          </div>
          
          <div className="uk-card-body" style={{ padding: "32px" }}>
            <div className="uk-grid uk-grid-medium uk-child-width-1-2@m" uk-grid="" style={{ marginTop: "0" }}>
            <div>
              <div className="uk-margin">
                <label className="uk-form-label" style={{ 
                  fontSize: "11px", 
                  color: "#999", 
                  textTransform: "uppercase", 
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  marginBottom: "6px",
                  display: "block"
                }}>
                  Title
                </label>
                <p style={{ 
                  fontSize: "15px", 
                  color: "#333", 
                  fontWeight: "500",
                  margin: "0"
                }}>{data.title || "-"}</p>
              </div>
            </div>

            <div>
              <div className="uk-margin">
                <label className="uk-form-label" style={{ 
                  fontSize: "11px", 
                  color: "#999", 
                  textTransform: "uppercase", 
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  marginBottom: "6px",
                  display: "block"
                }}>
                  Status
                </label>
                <span
                  style={{
                    display: "inline-block",
                    padding: "4px 14px",
                    borderRadius: "16px",
                    fontSize: "12px",
                    fontWeight: "600",
                    textTransform: "capitalize",
                    backgroundColor: data.status === "pending" 
                      ? "#1e87f0" 
                      : data.status === "approved" 
                      ? "#32d296" 
                      : "#f0506e",
                    color: "#fff"
                  }}
                >
                  {data.status || "-"}
                </span>
              </div>
            </div>

            <FieldItem label="First Name" value={data.firstName} />
            <FieldItem label="Last Name" value={data.lastName} />
            <FieldItem label="Email" value={data.email} />
            <FieldItem label="Primary Number" value={data.primaryNumber} />
            <FieldItem label="Landline Number" value={data.landlineNumber} />
            <FieldItem label="Current Business Name" value={data.currentBusinessName} />
            <FieldItem label="Business Address" value={data.businessAddress} />
            <FieldItem label="City" value={data.city} />
            <FieldItem label="State" value={data.state} />
            <FieldItem label="Market Area" value={data.marketArea} />
            <FieldItem label="Automotive Industry Experience" value={data.automotiveIndustry} />
            <FieldItem label="OEM Brand Affiliation" value={data.oemBrandAffiliation} />
            <FieldItem label="Brand Name" value={data.brandName} />
            <FieldItem label="Current Ownership" value={data.currentOwnership} />
            <FieldItem label="Other Current Ownership" value={data.otherCurrentOwnership} />
            <FieldItem label="Type of Facility" value={data.typeOfFacility?.replace(/_/g, ' ')} />
            <FieldItem label="Other Type of Facility" value={data.otherTypeOfFacility} />
            <FieldItem label="Operation Facility" value={data.operationFacility} />
            
            <FieldItem 
              label="Submitted At" 
              value={data.submittedAt ? new Date(data.submittedAt).toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              }) : "-"}
              isFullWidth={true}
            />
            
            <FieldItem 
              label="Created At" 
              value={data.createdAt ? new Date(data.createdAt).toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              }) : "-"}
              isFullWidth={true}
            />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealershipDetail;
